export default __webpack_public_path__ + "static/media/bgMobile.2633e5a9.jpg";